import type { ComponentPropsWithRef, ReactNode } from "react"

import type { JsonFieldValue, JsonObject } from "@/types/json"

export enum SimulationWrapperType {
  CUSTOM = "chime",
  API_WRAPPER = "api",
}

export interface ApiCallConfig {
  api_url: string
  method?: string
  request_body?: JsonFieldValue | string | null
  headers?: JsonFieldValue | string | null
  timeout?: number
}

export interface SimulationWrapperConfig {
  pre_simulation?: ApiCallConfig[]
  post_simulation?: ApiCallConfig[]
}

/** Returning false keeps a draft open when the editor cannot accept it. */
export type SimulationWrapperChangeHandler<T> =
  | ((value: T) => boolean)
  | ((value: T) => void)

interface SimulationWrapperData {
  type: SimulationWrapperType
  name: string
  display_name: string
  metadata?: JsonObject
}

export class SimulationWrapper {
  type: SimulationWrapperType
  name: string
  display_name: string
  metadata: JsonObject

  constructor(data: SimulationWrapperData) {
    this.type = data.type
    this.name = data.name
    this.display_name = data.display_name
    this.metadata = data.metadata || {}
  }

  render(): ReactNode {
    return null
  }

  renderTopLevelConfig(
    _config: SimulationWrapperConfig | null | undefined,
    _onConfigChange: SimulationWrapperChangeHandler<SimulationWrapperConfig>,
    _hideHeaderValues?: boolean,
    _onDraftOpen?: () => () => void,
  ): ReactNode {
    return null
  }

  renderTestCaseCell(
    _simulationMetadataInput: JsonObject | null | undefined,
    _onUpdate: SimulationWrapperChangeHandler<JsonObject>,
    _isExpanded: boolean,
    _width: string,
    _disabled = false,
    _cellProps?: ComponentPropsWithRef<"td">,
    _onDraftOpen?: () => () => void,
  ): ReactNode {
    return null
  }

  getDisplayName(): string {
    return this.display_name
  }

  getType(): SimulationWrapperType {
    return this.type
  }
}
